import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { auth, db } from "../firebase";
import { addDoc, collection, doc, getDoc, getDocs, setDoc, updateDoc } from "firebase/firestore";
import {
    Card,
    CardContent,
    Typography,
    Grid,
    TextField,
    Button,
    Box,
    Divider,
    InputAdornment,
    MenuItem,
} from "@mui/material";
import StoreIcon from "@mui/icons-material/Store";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ReceiptIcon from "@mui/icons-material/Receipt";
import QRCode from "qrcode";

export default function Restodetails() {
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
    });

    const [userData, setUserData] = useState(null);
    const [propertyId, setPropertyId] = useState(null);

    const [hotelname, setHotelname] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [address, setAddress] = useState("");
    const [city, setcity] = useState("");
    const [state, setstate] = useState("");
    const [pincode, setpincode] = useState("");
    const [gstname, setGstname] = useState("");
    const [gstno, setGstno] = useState("");
    const [roomposting, setroomposting] = useState('No');
    const [gstbill, setgstbill] = useState('No');
    const [customerQr, setcustomerQr] = useState('No');
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);

    useEffect(() => {
        const unsub = auth.onAuthStateChanged((user) => {
            if (!user) return;
            setUserData(user);
        });
        return () => unsub();
    }, []);

    useEffect(() => {
        if (!userData) return;

        const fetchAll = async () => {
            try {
                const roleRef = doc(db, "authroles", userData.uid);
                const roleSnap = await getDoc(roleRef);

                if (!roleSnap.exists() || !roleSnap.data().propertyId) return;

                setPropertyId(roleSnap.data().propertyId);

                const userRef = doc(db, "properties", roleSnap.data().propertyId);
                const snap = await getDoc(userRef);

                if (!snap.exists()) return;

                const d = snap.data();
                setHotelname(d.hotelname || "");
                setEmail(d.email || userData.email || "");
                setMobile(d.mobile || "");
                setAddress(d.address || "");
                setGstname(d.gstname || "");
                setGstno(d.gstno || "");
                setroomposting(d.roomposting || "");
                setgstbill(d.gstbill || "");
                setcustomerQr(d.customerQr || "");
                setLatitude(d.latitude || null);
                setLongitude(d.longitude || null);
                setcity(d.city || null);
                setpincode(d.pincode || null);
                setstate(d.state || null);
            } catch (err) {
                Toast.fire({ icon: "error", title: err.message });
            }
        };

        fetchAll();
    }, [userData]);


    const handleUpdate = async () => {
        if (!hotelname || mobile.length !== 10) {
            Toast.fire({ icon: "error", title: "Invalid input data" });
            return;
        }

        try {
            const ref = doc(db, "properties", propertyId);

            await updateDoc(
                ref,
                {
                    propertyId,
                    hotelname,
                    mobile,
                    address,
                    email,
                    city,
                    state,
                    pincode,
                    gstname,
                    gstno,
                    roomposting,
                    gstbill,
                    updatedAt: new Date(),
                    customerQr
                },
                { merge: true } // 🔥 magic line
            );

            Toast.fire({
                icon: "success",
                title: "Saved successfully",
            });
        } catch (err) {
            console.error(err);
            Toast.fire({
                icon: "error",
                title: "Save failed",
            });
        }
    };

    const handleUpdateLocation = async () => {
        if (!navigator.geolocation) {
            Toast.fire({ icon: "error", title: "Location not supported" });
            return;
        }

        try {
            const position = await new Promise((resolve, reject) =>
                navigator.geolocation.getCurrentPosition(resolve, reject)
            );

            const lat = position.coords.latitude;
            const lng = position.coords.longitude;

            const ref = doc(db, "properties", propertyId);

            await updateDoc(ref, {
                latitude: lat,
                longitude: lng,
                geoRadius: 100,
                updatedAt: new Date(),
            });

            setLatitude(lat);
            setLongitude(lng);

            Toast.fire({ icon: "success", title: "Location Updated" });

            // 🔥 Regenerate all seating QR codes
            // await regenerateAllQRCodes();

        } catch (err) {
            Toast.fire({ icon: "error", title: "Location update failed" });
        }
    };

    const regenerateAllQRCodes = async () => {
        try {
            const seatingSnap = await getDocs(
                collection(db, "seatings")
            );

            const tables = seatingSnap.docs
                .map((doc) => doc.data())
                .filter((s) => s.propertyId === propertyId);

            for (let table of tables) {
                const link = `http://localhost:3000/menu/${propertyId}/${table.seatname}`;

                const qrImage = await QRCode.toDataURL(link);

                await addDoc(collection(db, "seatingqrcodes"), {
                    link,
                    propertyid: propertyId,
                    tableid: table.seatname,
                    qrcode: qrImage,
                    status: "Active",
                    regeneratedAt: new Date(),
                });
            }

            Toast.fire({ icon: "success", title: "All QR Codes Regenerated" });

        } catch (err) {
            console.log(err);
        }
    };

    return (
        <Box className="" sx={{ p: 3 }}>
            <Card
                sx={{
                    mx: "auto",
                    borderRadius: 4,
                    boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
                }}
            >
                {/* HEADER */}
                <Box
                    sx={{
                        p: 2,
                    }}
                >
                    <Typography variant="h5" fontWeight="bold">
                        Restaurant Details
                    </Typography>

                </Box>

                <CardContent >
                    <Grid className="row" spacing={3}>
                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                fullWidth size="small"
                                label="Hotel Name"
                                value={hotelname}
                                onChange={(e) => setHotelname(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <StoreIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                fullWidth size="small"
                                onChange={(e) => setEmail(e.target.value)}
                                label="Email"
                                value={email}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <EmailIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                fullWidth size="small"
                                label="Mobile"
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <PhoneIcon />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                fullWidth size="small"
                                label="Address"
                                value={address}
                                onChange={(e) => setAddress(e.target.value)}
                            />
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                fullWidth size="small"
                                label="City"
                                value={city}
                                onChange={(e) => setcity(e.target.value)}
                            />
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                fullWidth size="small"
                                label="State"
                                value={state}
                                onChange={(e) => setstate(e.target.value)}
                            />
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                fullWidth size="small"
                                label="Pincode"
                                value={pincode}
                                onChange={(e) => setpincode(e.target.value)}

                            />
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                fullWidth size="small"
                                label="GST Name"
                                value={gstname}
                                onChange={(e) => setGstname(e.target.value)}
                            />
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                fullWidth size="small"
                                label="GST No"
                                value={gstno}
                                onChange={(e) => setGstno(e.target.value)}
                            />
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                select
                                label="GST Bill Enable"
                                size="small"
                                fullWidth
                                value={gstbill}
                                onChange={(e) => setgstbill(e.target.value)}
                            >
                                <MenuItem value="No">No</MenuItem>
                                <MenuItem value="Yes">Yes</MenuItem>

                            </TextField>
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                select
                                disabled="true"
                                label="Room Posting"
                                size="small"
                                fullWidth
                                value={roomposting}
                                onChange={(e) => setroomposting(e.target.value)}
                            >
                                <MenuItem value="No">No</MenuItem>
                                <MenuItem value="Yes">Yes</MenuItem>

                            </TextField>
                        </Grid>



                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                select
                                disabled="true"
                                label="Customer Qr Orders"
                                size="small"
                                fullWidth
                                value={customerQr}
                                onChange={(e) => setcustomerQr(e.target.value)}
                            >
                                <MenuItem value="No">No</MenuItem>
                                <MenuItem value="Yes">Yes</MenuItem>

                            </TextField>
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                fullWidth size="small"
                                label="Latitude"
                                value={latitude}
                                onChange={(e) => setLatitude(e.target.value)}

                            />
                        </Grid>

                        <Grid className="col-sm-3 mb-3">
                            <TextField
                                fullWidth size="small"
                                label="Longitude"
                                value={longitude}
                                onChange={(e) => setLongitude(e.target.value)}

                            />
                        </Grid>
                    </Grid>

                    <Divider sx={{ my: 4 }} />

                    <Box textAlign="center">
                        <Button
                            size="large"
                            variant="contained"
                            onClick={handleUpdate}
                            sx={{
                                px: 6,
                                py: 1.5,
                                fontSize: 16,
                                borderRadius: 3,
                                background: "linear-gradient(135deg, teal, #006c4f)",
                            }}
                        >
                            Save Changes
                        </Button>
                    </Box>

                    <Box textAlign="center" mt={3}>
                        <Button
                            variant="outlined"
                            onClick={handleUpdateLocation}
                            sx={{
                                px: 5,
                                py: 1.5,
                                borderRadius: 3,
                            }}
                        >
                            Update Restaurant Location
                        </Button>
                    </Box>

                    {latitude && longitude && (
                        <Card sx={{ mt: 4, borderRadius: 3 }}>
                            <CardContent>
                                <Typography variant="h6" fontWeight="bold" mb={2}>
                                    Restaurant Location
                                </Typography>

                                <iframe
                                    width="100%"
                                    height="250"
                                    style={{ borderRadius: "12px" }}
                                    loading="lazy"
                                    allowFullScreen
                                    src={`https://www.google.com/maps?q=${latitude},${longitude}&z=17&output=embed`}
                                ></iframe>

                                <Typography variant="body2" mt={1}>
                                    Lat: {latitude} | Lng: {longitude}
                                </Typography>
                            </CardContent>
                        </Card>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
}
